var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#F1F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1781 15.7183C12.3298 15.809 12.4815 15.8392 12.633 15.8392C12.906 15.8392 13.179 15.6879 13.3612 15.4458C13.6341 14.9921 13.9678 14.5987 14.3015 14.2053C14.6352 13.8725 14.605 13.328 14.2713 13.0254C13.9376 12.6926 13.3916 12.7227 13.0882 13.0556C12.6635 13.5093 12.269 14.0238 11.9353 14.5683C11.6623 14.9619 11.7836 15.4762 12.178 15.7183L12.1781 15.7183Z",
    fill: "#58595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8803 26.6098C15.6669 26.0653 14.5748 25.2484 13.7859 24.1894C13.5129 23.8264 12.9668 23.7357 12.6028 24.0381C12.2388 24.3103 12.1478 24.855 12.4511 25.218C13.4219 26.4887 14.7263 27.5173 16.2128 28.1829C16.3341 28.2435 16.4253 28.2435 16.5465 28.2435C16.8802 28.2435 17.1837 28.062 17.3352 27.7292C17.5172 27.3056 17.305 26.7913 16.8803 26.6098V26.6098Z",
    fill: "#58595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4513 21.4061C12.1783 20.4077 12.1478 19.3489 12.2693 18.3504C12.33 17.8967 12.0266 17.4731 11.5412 17.4126C11.0862 17.352 10.6615 17.6546 10.6008 18.1387C10.4188 19.3792 10.4795 20.6197 10.8133 21.86C10.9042 22.2534 11.2682 22.4955 11.6324 22.4955C11.6931 22.4955 11.7841 22.4955 11.8448 22.4653C12.2998 22.3136 12.5728 21.8598 12.4513 21.4061L12.4513 21.4061Z",
    fill: "#58595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8216 10.7981C17.2561 10.9243 17.5056 11.3776 17.379 11.8109C17.2525 12.2439 16.7979 12.4927 16.3635 12.3665C15.9293 12.2403 15.6798 11.787 15.8064 11.3538C15.9327 10.9207 16.3875 10.6719 16.8216 10.7981Z",
    fill: "#58595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9747 10C19.5197 10 19.1252 10.363 19.1252 10.8472C19.1252 11.3009 19.4892 11.6943 19.9747 11.6943C24.2824 11.6943 27.8014 15.2039 27.8014 19.5C27.8014 20.317 27.6801 21.1337 27.407 21.9506C27.2552 22.4044 27.498 22.8583 27.9529 23.0097C28.0439 23.0398 28.1349 23.0398 28.2259 23.0398C28.5899 23.0398 28.9236 22.8279 29.0146 22.4649C29.3483 21.4967 29.5 20.4985 29.5 19.5C29.5002 14.266 25.2228 10 19.9744 10L19.9747 10Z",
    fill: "#58595B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7383 24.7644C24.2518 26.3679 22.1587 27.3057 19.9744 27.3057C19.5195 27.3057 19.125 27.6687 19.125 28.1529C19.125 28.6066 19.489 29 19.9744 29C22.6136 29 25.1922 27.8806 26.9821 25.914C27.2855 25.5811 27.2855 25.0367 26.9213 24.734C26.5876 24.4012 26.0719 24.4316 25.7382 24.7644L25.7383 24.7644Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.51d6ed1a13bbf49f2c8febdc0dc8c076.svg";
export { ForwardRef as ReactComponent };